import { render, staticRenderFns } from "./CompetitionDetails.vue?vue&type=template&id=73783ac0"
import script from "./CompetitionDetails.vue?vue&type=script&lang=js"
export * from "./CompetitionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports